/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 15:31:42
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-09 17:39:23
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/index.ts
 */
import { generateCarousel } from './Carousel';
import { generateLongCanvas } from './LongCanvas';
import { generatePoster } from './Poster';
import { generateProductCarousel } from './ProductCarousel';
import { generateProductGridDisplay } from './ProductGrid';
import { generateProductListDisplay } from './ProductList';
import { generateSubscription } from './Subscription';
import { generateText } from './Text';
import { generateArticleList } from './ArticleList';
import { generateArticleCarousel } from './ArticleCarousel';
import { generateVideo } from './Video';
import { generateResponsiveImageCarousel } from './ResponsiveImageCarousel';
import { generateResponsiveProductCarousel } from './ResponsiveProductCarousel';
import { generateResponsiveContentPageCarousel } from './ResponsiveContentPageCarousel';
import { generateResponsiveSubscription } from './ResponsiveSubscription';
import { generateResponsivePoster } from './ResponsivePoster';
import { generateResponsiveProductGrid } from './ResponsiveProductGrid';
import { generateResponsiveContentGrid } from './ResponsiveContentGrid';
import { generateResponsiveText } from './ResponsiveText';
import { generateResponsivePosterTab } from './ResponsivePosterTab';
import { generateResponsiveProductTab } from './ResponsiveProductTab';
import { generateResponsiveContentTab } from './ResponsiveContentTab';

export {
  generateCarousel,
  generateLongCanvas,
  generatePoster,
  generateProductCarousel,
  generateProductGridDisplay,
  generateProductListDisplay,
  generateSubscription,
  generateText,
  generateArticleCarousel,
  generateArticleList,
  generateVideo,
  generateResponsiveImageCarousel,
  generateResponsiveProductCarousel,
  generateResponsiveContentPageCarousel,
  generateResponsiveSubscription,
  generateResponsivePoster,
  generateResponsiveProductGrid,
  generateResponsiveContentGrid,
  generateResponsiveText,
  generateResponsivePosterTab,
  generateResponsiveProductTab,
  generateResponsiveContentTab,
};
